import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PayOnlineDashboardComponent } from './pay-online-dashboard/pay-online-dashboard.component';
import { PaymentLinkComponent } from './payment-link/payment-link.component';
import { SuccessOrFailureComponent } from './success-or-failure/success-or-failure.component';
// import { SuccessOrFailureComponent } from './success-or-failure/success-or-failure.component';


const routes: Routes = [
  {
    path: 'payment',
    component: PaymentLinkComponent,
    children: [
      {
        path: 'payonline/:jwt/:uniref/:mobile/:date/:studentName',component: PayOnlineDashboardComponent
      },
      {
        path:'paymentResults', component:SuccessOrFailureComponent
      }

    ]

  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PayOnlineRoutingModule { }
